import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { FirebaseAuth } from 'private-angular-vhframeworks';
import { VhViethasWebAPPAdmin } from 'vhwebapp';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
//BrLuzTwMyFUspBz3UZObmBssGUl1
  constructor(
    private router: Router,
    private vhAuth: FirebaseAuth,
    private vhViethasWebAPPAdmin: VhViethasWebAPPAdmin
    ) {
      this.vhViethasWebAPPAdmin.initializeProject("bvhsales", "firebase", 'research', '', 100522, 'lXjeqUwuBqScIkuf7sibcx2SF383')
    .then(() => {
          //return true
      }) 
     }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.vhAuth.onAuthStateChanged().then((user: any) => {
      if (user) return true;
      this.router.navigate(['/viethas/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }, (err) => {
      this.router.navigate(['/viethas/login'], { queryParams: { returnUrl: state.url } });
      return false
    });
  }
}